import { useEffect, useState } from 'react';
import { useUIStore } from '~/store/useUIStore';
import { ProfileCompletionModal } from '~/components/ui/modals/ProfileCompletionModal';
import { createClient } from '~/lib/providers/supabase/client';
import { useSearchParams, useRouter } from 'next/navigation';
import { useAgency } from '~/hooks/useAgency';

export const ProfileCompletionHandler = () => {
  const supabase = createClient();
  const { agency } = useAgency();
  const showProfileCompletionModal = useUIStore(
    (state) => state.showProfileCompletionModal
  );
  const setProfileData = useUIStore((state) => state.setProfileData);
  const searchParams = useSearchParams();
  const router = useRouter();
  const [isChecking, setIsChecking] = useState(true);

  const requireProfileCompletion = searchParams?.get('rpc');

  useEffect(() => {
    const checkUserProfile = async () => {
      try {
        setProfileData(null);

        // SUPABASE: Auth call
        const {
          data: { user },
        } = await supabase.auth.getUser();

        if (user) {
          const { data: userData, error } = await supabase
            .from('users')
            .select('*')
            .eq('uuid', user.id)
            .single();

          if (!error) {
            setProfileData(userData);
          }

          if (
            !error &&
            userData &&
            (!userData.name || !userData.phone || !userData.terms_accepted_at)
          ) {
            showProfileCompletionModal(userData);
          } else if (error && error.code !== 'PGRST116') {
            console.error('Error checking user profile:', error);
          }
        }
      } catch (error) {
        console.error('Error in profile completion check:', error);
      } finally {
        setIsChecking(false);
      }
    };

    if (requireProfileCompletion === 'true') {
      showProfileCompletionModal();

      const url = new URL(window.location.href);
      url.searchParams.delete('rpc');
      router.replace(url.toString().replace(window.location.origin, ''));

      checkUserProfile();
    } else {
      checkUserProfile();
    }
  }, [
    requireProfileCompletion,
    showProfileCompletionModal,
    setProfileData,
    router,
    supabase,
    agency?.id,
  ]);

  return <ProfileCompletionModal />;
};
